import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createAttributeCategory',
    serviceName: 'admin',
    query: gql`
      mutation createAttributeCategory($title: String!, $description: String) {
        createAttributeCategory(title: $title, description: $description) {
          messages
        }
      }
    `,
  },
};

export default schema;
